import { Transforms } from 'slate'

export function removeTable(table, editor) {
  if (editor && table) {
    Transforms.removeNodes(editor, {
      match: n => n.type === 'table',
      at: table[1],
    });
  }
}
